// extracted by mini-css-extract-plugin
export default {"authentication__header":"Auth_authentication__header__oCH4v","authentication":"Auth_authentication__C22fn"};